import { render, staticRenderFns } from "./CounselorAvatar.vue?vue&type=template&id=6c8df221&"
import script from "./CounselorAvatar.vue?vue&type=script&lang=js&"
export * from "./CounselorAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CounselorAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports